import { einvoiceLabel, einvoiceTone, type EInvoiceStatus } from '@/lib/einvoicing';
import { useLanguage } from '@/lib/i18n';
import { cn } from '@/lib/utils';

const TONES = {
  muted: 'border-border bg-muted text-muted-foreground',
  info: 'border-info/30 bg-info/10 text-info',
  success: 'border-success/30 bg-success/10 text-success',
  warning: 'border-warning/30 bg-warning/10 text-warning',
  danger: 'border-destructive/30 bg-destructive/10 text-destructive',
} as const;

/** E-invoice status chip (document 05 StatusBadge rules: the text is always there). */
export function EInvoiceChip({
  status,
  needsAttention,
  className,
  prefix,
}: {
  status: EInvoiceStatus;
  needsAttention?: boolean;
  className?: string;
  /** "E-invoice:" where the chip sits next to the document's own status. */
  prefix?: string;
}) {
  useLanguage(); // the label is read from the catalogue; re-render when the language changes
  const r = { status, needsAttention: needsAttention ?? false };
  return (
    <span
      data-testid="einvoice-chip"
      className={cn(
        'inline-flex items-center rounded-full border px-2 py-0.5 text-xs font-medium whitespace-nowrap',
        TONES[einvoiceTone(r)],
        className,
      )}
    >
      {prefix ? `${prefix} ` : ''}
      {einvoiceLabel(r)}
    </span>
  );
}
